<script>
    import { Pie } from "vue-chartjs";
    export default {
        extends: Pie,
        data(){
            return {
                config: {
                    labels: [this.$t('income'), this.$t('expense'), this.$t('net_profit')],
                    datasets: [
                        {
                            backgroundColor: ["#4dbd74", "#f86c6b", "#20a8d8"],
                            data: [100, 40, 65]
                        }
                    ]
                },
                options: {
                    responsive: true, 
                    maintainAspectRatio: false,
                    pieceLabel: {
                        mode: 'percentage',
                        precision: 2
                    }
                }
            }
        },
        mounted() {
            this.renderChart(this.config, this.options);
        }
    };
</script>